import React, { Component } from "react";
import ContactUs from "../Common/ContactUs";
import Transition from 'react-transition-group/Transition';
class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAbloutPage:false
        };
    }
    componentWillMount(){
        if(Object.getOwnPropertyNames(this.props).length > 0 && this.props.match.url === '/about'){
            this.setState({isAbloutPage: true})
        }
    }
    render() {
        const {isAbloutPage} = this.state;
        return (
            <div className="film-page">
            {(isAbloutPage) &&<img src="/assets/images/eathdeck/about-banner.png" />}
                <div className="row">
                    <div className="medium-12 columns">
                        <div className="about-us">
                            <h2 className="text-center">About earthDECKS</h2>
                            <p className="text-center">
                                earthDECKS is developing new media to network like-minded environmentalists. Our collaborative-intelligence (CIQ) social platform supports learning and game-changing. Our flagship experience, PLASTIC, introduces users to stories about game-changers in a Plastic Innovation Network [PIN].
                            </p>
                            <p className="text-center">earthDECKS is a project of the 501 (c) (3)</p>
                            <p className="text-center ocean"><img src="/assets/images/eathdeck/the_ocan_foundation.png" /></p>
                            <p className="text-center">All contributions are tax deductible. You will receive an automated <br/> email acknowledging your gift, which you can use for tax purposes.</p>
                            <p className="text-center donate"><a href="https://www.oceanfdn.org/donate/earthdecksorg-ocean-network" className="btn-primary secondary-gradient-bg" target="_blank"><img src="/assets/images/eathdeck/donate_icon.png" /> Donate</a></p>
                        </div>
                    </div>
                </div>
                <ContactUs />
            </div>
        )
    }
}

export default About;



// WEBPACK FOOTER //
// ./components/Common/About.js